import PurchaseBuyerFile from '@/types/purchaseRequest/purchaseBuyerFile'
import { BaseService } from './../../base'
export class PurchaseBuyerFileService extends BaseService<PurchaseBuyerFile>() {
    static get entity (): string {
        return 'purchase_buyer_file'
    }
    static get responseName (): string {
        return 'purchase_buyer_file'
    }
}